export const BOOK_A_DEMO_URL = 'https://mybites.io/book-a-demo/';
export const signInDataSet = { cy: 'sign-in-button' };
